module.exports = __webpack_public_path__ + "static/media/werun_anywhere.c90a2597.png";